import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SvgHeader from "./SvgHeader";
import SvgFullScreenDiv from "./SvgFullScreenDiv";
import SvgGrid from "./SvgGrid";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function SvgPage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SvgHeader />
      <SvgGrid />
      <SvgFullScreenDiv />
    </div>
  );
}

export default SvgPage;
